import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { getAppDevelopmentSubtypeContent } from './appDevelopmentSubtypeContent'

const AppDevelopmentSubtypePage = ({ typeKey, subtypeSlug }) => {
  const content = getAppDevelopmentSubtypeContent(typeKey, subtypeSlug)
  if (!content) return null

  const subtypePageContent = {
    ...content,
    enableSubtypeCostGuide: ['healthcare', 'taxi', 'fintech', 'wallet'].includes(content.typeKey),
    costGuidePath: ['healthcare', 'taxi', 'fintech', 'wallet'].includes(content.typeKey) ? `/app-development/${content.parentTitle.toLowerCase().replace(/ app development$/, '-app-development').replace(/\s+/g, '-')}/${content.subtypeSlug}/cost/` : undefined,
    costGuideImage: ['healthcare', 'taxi', 'fintech', 'wallet'].includes(content.typeKey) ? `/assets/app-development-subtypes/${content.parentTitle.toLowerCase().replace(/ app development$/, '-app-development').replace(/\s+/g, '-')}/${content.subtypeSlug}/cost/carousel.png` : undefined,
    keywordSectionSubheading: undefined,
    keywordNarrative: undefined,
    testimonialsHeading: `${content.title} Founder Feedback`,
    faqHeading: `${content.title} FAQs`,
    subtypesHeading: `Types Of ${content.parentTitle} We Offer`,
    appTypesEyebrow: 'INDUSTRY SOLUTIONS',
    appTypesHeading: 'Types Of App Development We Offer',
    proposalEyebrow: 'SEND YOUR',
    proposalHeading: `Free ${content.title} Proposal`,
    proposalButtonLabel: 'Send Message',
    blogsEyebrow: 'LEARN MORE',
    blogsHeading: 'About Our App Development Company',
    blogsButtonLabel: 'View All Blogs',
    processEyebrow: 'HOW WE WORK',
    processHeading: 'A Product Process You Can Review',
    parallaxTitle: `${content.title} From Product Strategy to Launch`
  }

  return <AppDevelopmentTypePage content={subtypePageContent} />
}

export default AppDevelopmentSubtypePage
